export class PostContactParams {
  // Equivalent to PostContact as a request body
  userId?: number;
  typeSociete?: boolean;
  typeContactId?: number;
  nom?: string;
  prenom?: string;
  nomInterne?: string;
  titre?: string;
  fonction?: string;
  langueId?: number;
  nePlusUtiliser?: boolean;
  numeroCarteNISS?: string;
  pasDeRNBelge?: boolean;
  dateNaissance?: string;
  naissanceLieu?: string;
  dateDeces?: string;
  etatCivil?: string;
  sexe?: string;
  nationalite?: string;
  dateEntreeFonction?: string;
  dateSortieFonction?: string;
  gerantSociete?: string;
  secteurActivite?: string;
  societeFormeJuridiqueId?: number;
  societeParente?: number;
  societeParenteLienEtablissement?: string;
  commentaires?: string;
  signatureCertifactNom?: string;
  signatureDescription?: string;
  signature1?: string;
  signature2?: string;
  tva?: string;
  tvA_Digits?: string;
  pasDeTVABelge?: boolean;
  siteWeb?: string;
  siteWeb2?: string;
  verrouille?: boolean;
  bce?: string;
  paysContactID?: number;
  listContactsAdresses?: [
    {
      contactID?: number;
      description?: string;
      type?: string;
      adresse?: {
        structure_LocaliteId?: number;
        structure_RueId?: number;
        structure_RueNumero?: string;
        structure_RueBoite?: string;
        langueId?: number;
        impression_Adresse?: string;
        impression_CodePostal?: string;
        impression_Localite?: string;
        impression_Pays?: string;
        telephone?: string;
        fax?: string;
        gsm?: string;
        site?: string;
        mail?: string;
      };
    },
  ];
}

export class ContactPutParams {
  // Equivalent to PutContact
  typeSociete?: boolean;
  typeContactId?: number;
  nom?: string;
  prenom?: string;
  nomInterne?: string;
  titre?: string;
  fonction?: string;
  langueId?: number;
  nePlusUtiliser?: boolean;
  numeroCarteNISS?: string;
  pasDeRNBelge?: boolean;
  dateNaissance?: string;
  naissanceLieu?: string;
  dateEntreeFonction?: string;
  dateDeces?: string;
  etatCivil?: string;
  sexe?: string;
  nationalite?: string;
  dateSortieFonction?: string;
  gerantSociete?: string;
  secteurActivite?: string;
  societeFormeJuridiqueId?: number;
  societeParente?: number;
  societeParenteLienEtablissement?: string;
  commentaires?: string;
  signatureCertifactNom?: string;
  signatureDescription?: string;
  signature1?: string;
  signature2?: string;
  tva?: string;
  tvA_Digits?: string;
  pasDeTVABelge?: boolean;
  siteWeb?: string;
  siteWeb2?: string;
  verrouille?: boolean;
  bce?: string;
  paysContactID?: number;
}
